// extracted by mini-css-extract-plugin
export default {"container":"Faq_container__sj9Zo","content":"Faq_content__zPP2r","heading":"Faq_heading__WDOn4","items":"Faq_items__yS9-d","label":"Faq_label__Yjt6Y","list":"Faq_list__QtWgD"};